if (!customElements.get('hx-product')) {
  customElements.define('hx-product', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.events = { signal: this.controller.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.data = JSON.parse(this.querySelector('[data-hx-product-data]').textContent);
      this.form = this.querySelector('.hx-product-form');
      this.explicitPlan = new URL(location.href).searchParams.has('selling_plan');
      this.variantSelect = this.form.querySelector('[data-hx-variant-select]');
      this.planSelect = this.form.querySelector('[data-hx-selling-plan]');
      if (new URL(location.href).searchParams.get('purchase_option') === 'one_time') this.planSelect.value = '';
      this.quantity = this.form.elements.quantity;
      this.status = this.querySelector('[data-hx-status]');
      this.sticky = this.querySelector('.hx-product-sticky');
      this.setupGallery();
      this.setupTabs();
      this.setupChapters();
      this.setupReveals();
      this.setupAmbientVideos();
      this.setupTestimonials();
      this.setupRecommendations();
      this.querySelectorAll('[data-hx-open-composition]').forEach(link => link.addEventListener('click', () => {
        const detail = this.querySelector(link.hash);
        if (detail?.tagName === 'DETAILS') detail.open = true;
      }, this.events));
      this.querySelector('.hx-product-native-variant')?.setAttribute('hidden', '');
      this.querySelector('.hx-product-variant-pills')?.removeAttribute('hidden');
      this.querySelector('.hx-product-purchase-modes').hidden = false;
      this.form.addEventListener('change', event => {
        if (event.target.name === 'hx_variant') {
          this.variantSelect.value = event.target.value;
          this.syncVariant(true);
        } else if (event.target === this.variantSelect) this.syncVariant(true);
        else if (event.target.name === 'hx_purchase_mode') {
          const subscribing = event.target.value === 'subscription';
          this.planSelect.value = subscribing ? String(this.activePlan || this.variant.plans[0]?.id || '') : '';
          this.syncPlan(true);
        } else if (event.target === this.planSelect) { this.explicitPlan = true; this.syncPlan(true); }
        else if (event.target === this.quantity) this.syncQuantity(true);
      }, this.events);
      this.quantity.addEventListener('input', () => this.syncQuantity(false), this.events);
      this.querySelectorAll('[data-hx-quantity-step]').forEach(button => button.addEventListener('click', () => {
        if (Number(button.dataset.hxQuantityStep) > 0) this.quantity.stepUp();
        else this.quantity.stepDown();
        this.syncQuantity(true);
        this.motion(this.quantity, [{ backgroundColor: '#d6edf6', transform: 'scale(.95)' }, { backgroundColor: 'transparent', transform: 'scale(1)' }], 330);
      }, this.events));
      this.form.addEventListener('submit', event => this.addToCart(event), this.events);
      this.syncVariant(false);
      if (this.sticky) {
        const cartButton = this.sticky.querySelector('.hx-product-sticky-cart');
        cartButton.addEventListener('click', event => {
          const count = Number(document.querySelector('arte-cart-drawer .v3-cart-content')?.dataset.count ?? cartButton.querySelector('[data-v3-cart-count]')?.textContent) || 0;
          if (count > 0) return;
          event.preventDefault();
          event.stopPropagation();
          const feedback = cartButton.querySelector('.hx-product-empty-feedback');
          feedback.hidden = false;
          this.motion(cartButton, [{ boxShadow: '0 0 0 0 #2594ba44' }, { boxShadow: '0 0 0 10px #2594ba00' }], 700);
          clearTimeout(this.emptyCartTimer);
          this.emptyCartTimer = setTimeout(() => { feedback.hidden = true; }, 2800);
        }, this.events);
        this.stickyUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const add = this.form.querySelector('[data-hx-add]').getBoundingClientRect();
            const before = add.top >= innerHeight && scrollY > 160;
            const show = before || add.bottom < 100;
            this.sticky.classList.toggle('is-choose', before);
            const choose = this.sticky.querySelector('[data-hx-sticky-choose]');
            if (choose) choose.hidden = !before;
            this.sticky.hidden = !show;
            document.body.classList.toggle('hx-product-sticky-active', show);
          });
        };
        addEventListener('scroll', this.stickyUpdate, { passive: true, signal: this.controller.signal });
        addEventListener('resize', this.stickyUpdate, this.events);
        this.stickyUpdate();
      }
      this.classList.add('is-enhanced');
    }
    motion(element, frames, duration = 350) {
      if (!this.reduced.matches && element?.animate) element.animate(frames, { duration, easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
    setupGallery() {
      this.media = [...this.querySelectorAll('[data-hx-media]')];
      this.thumbnails = [...this.querySelectorAll('[data-hx-thumbnail]')];
      this.gallery = this.querySelector('[data-hx-gallery]');
      this.allMedia = this.media;
      this.allThumbnails = this.thumbnails;
      this.mediaIndex = Math.max(0, this.media.findIndex(media => media.classList.contains('is-active')));
      this.showMedia(this.mediaIndex, false);
      this.querySelector('.hx-product-thumbnails')?.removeAttribute('hidden');
      this.allThumbnails.forEach(button => button.addEventListener('click', () => {
        const index = this.thumbnails.indexOf(button);
        if (index >= 0) this.showMedia(index, true);
      }, this.events));
      this.querySelectorAll('[data-hx-media-step]').forEach(button => button.addEventListener('click', () => this.showMedia((this.mediaIndex + Number(button.dataset.hxMediaStep) + this.media.length) % this.media.length, true), this.events));
      const lightbox = this.querySelector('.hx-product-lightbox');
      this.lightbox = lightbox;
      this.mobileGallery = matchMedia('(max-width: 749px)');
      this.setupGallerySwipe();
      this.disableMobileZoom = !this.gallery?.hasAttribute('data-hx-variant-gallery');
      this.classList.toggle('hx-no-mobile-zoom', this.disableMobileZoom);
      const zoomLinks = [...this.querySelectorAll('[data-hx-zoom]')].map(link => ({
        link, href: link.getAttribute('href'), label: link.getAttribute('aria-label')
      }));
      const syncZoom = () => {
        const disabled = this.mobileGallery.matches && this.disableMobileZoom;
        if (disabled && lightbox.open) lightbox.close();
        zoomLinks.forEach(({ link, href, label }) => {
          if (disabled) {
            link.removeAttribute('href');
            link.removeAttribute('aria-label');
            link.setAttribute('tabindex', '-1');
          } else {
            if (href) link.setAttribute('href', href);
            if (label) link.setAttribute('aria-label', label);
            link.removeAttribute('tabindex');
          }
        });
      };
      this.mobileGallery.addEventListener('change', syncZoom, this.events);
      syncZoom();
      this.querySelectorAll('[data-hx-zoom]').forEach(link => link.addEventListener('click', event => {
        if (this.mobileGallery.matches && this.disableMobileZoom) { event.preventDefault(); return; }
        if (!lightbox.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.zoomTrigger = link;
        const image = new Image();
        image.src = link.href;
        image.alt = link.querySelector('img').alt;
        lightbox.querySelector('[data-hx-zoom-image]').replaceChildren(image);
        lightbox.showModal();
        document.body.classList.add('hx-product-lightbox-open');
      }, this.events));
      lightbox.querySelector('[data-hx-close]').addEventListener('click', () => lightbox.close(), this.events);
      lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); }, this.events);
      lightbox.addEventListener('close', () => {
        document.body.classList.remove('hx-product-lightbox-open');
        if (this.zoomTrigger?.isConnected) this.zoomTrigger.focus();
      }, this.events);
    }
    setupGallerySwipe() {
      const surface = this.gallery?.querySelector('.hx-product-media-list');
      if (!surface) return;
      surface.classList.add('hx-gallery-swipe-surface');
      let start = null;
      surface.addEventListener('pointerdown', event => {
        start = null;
        if (!this.mobileGallery.matches || !event.isPrimary || this.media.length < 2) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('video,iframe,model-viewer,input,button,select,textarea')) return;
        start = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { passive: true, ...this.events });
      window.addEventListener('pointerup', event => {
        const gesture = start;
        if (!gesture || gesture.id !== event.pointerId) return;
        start = null;
        if (!this.mobileGallery.matches || this.media.length < 2) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        const threshold = Math.max(32, Math.min(64, surface.clientWidth * .12));
        if (Math.abs(dx) < threshold || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        this.ignoreGalleryClickUntil = Date.now() + 500;
        const direction = dx < 0 ? 1 : -1;
        this.showMedia((this.mediaIndex + direction + this.media.length) % this.media.length, true, direction);
      }, { passive: true, ...this.events });
      window.addEventListener('pointercancel', () => { start = null; }, this.events);
      surface.addEventListener('dragstart', event => {
        if (this.mobileGallery.matches) event.preventDefault();
      }, this.events);
      surface.addEventListener('click', event => {
        if (Date.now() < (this.ignoreGalleryClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, ...this.events });
    }
    showMedia(index, animate, direction = 0) {
      if (!this.media.length) return;
      this.mediaIndex = index;
      this.media.forEach((media, current) => {
        const active = current === index;
        media.hidden = !active;
        if (!active) {
          media.querySelectorAll('video').forEach(video => video.pause());
          media.querySelectorAll('iframe').forEach(frame => {
            if (frame.src.includes('youtube')) frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
            else if (frame.src.includes('vimeo')) frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), '*');
          });
        }
      });
      this.thumbnails.forEach((button, current) => button.setAttribute('aria-pressed', String(current === index)));
      if (animate) {
        this.motion(this.media[index], [{ opacity: .4, transform: direction ? `translateX(${direction * 22}px)` : 'translateY(6px)' }, { opacity: 1, transform: 'translate(0)' }]);
        const thumb = this.thumbnails[index];
        if (thumb) thumb.parentElement.scrollTo({ left: thumb.offsetLeft - thumb.parentElement.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2, behavior: this.reduced.matches ? 'instant' : 'smooth' });
      }
    }
    syncGalleryFormat(animate) {
      if (this.gallery?.hasAttribute('data-hx-standard-nad-gallery')) {
        const format = this.variant.title.match(/\b(180|90|60|30)\b/)?.[1] || this.gallery.dataset.hxDefaultFormat;
        this.querySelectorAll('[data-hx-standard-format]').forEach(item => { item.hidden = item.dataset.hxStandardFormat !== format; });
        return;
      }
      if (!this.gallery?.hasAttribute('data-hx-variant-gallery')) return;
      const format = this.variant.title.match(/\b(180|90|60|30)\b/)?.[1] || this.gallery.dataset.hxDefaultFormat;
      if (format === this.galleryFormat) return;
      const media = this.allMedia.filter(item => item.dataset.hxGalleryFormat === format);
      if (!media.length) return;
      this.galleryFormat = format;
      this.allMedia.forEach(item => { item.hidden = true; });
      this.allThumbnails.forEach(item => { item.hidden = item.dataset.hxGalleryFormat !== format; });
      this.media = media;
      this.thumbnails = this.allThumbnails.filter(item => item.dataset.hxGalleryFormat === format);
      this.showMedia(0, animate);
    }
    setupTabs() {
      const group = this.querySelector('[data-hx-tabs]');
      if (!group) return;
      const tabs = [...group.querySelectorAll('[data-hx-tab]')];
      const panels = [...group.querySelectorAll('[data-hx-panel]')];
      group.querySelector('nav').setAttribute('role', 'tablist');
      const activate = (index, animate) => {
        tabs.forEach((tab, current) => {
          const selected = current === index;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-selected', String(selected));
          tab.setAttribute('aria-controls', panels[current].id);
          tab.tabIndex = selected ? 0 : -1;
          panels[current].hidden = !selected;
          panels[current].setAttribute('role', 'tabpanel');
          panels[current].setAttribute('aria-labelledby', tab.id);
          panels[current].tabIndex = 0;
        });
        if (animate) this.motion(panels[index], [{ opacity: .15, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], 450);
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', event => { event.preventDefault(); activate(index, true); }, this.events);
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(next, true);
          tabs[next].focus();
        }, this.events);
      });
      const initial = tabs.findIndex(tab => tab.hash === location.hash);
      activate(initial >= 0 ? initial : 0, false);
    }
    syncVariant(updateUrl) {
      if (updateUrl) this.explicitPlan = false;
      const previousPlan = this.planSelect.value;
      const previousPlanName = this.variant?.plans.find(plan => String(plan.id) === previousPlan)?.name;
      const subscribing = Boolean(previousPlan);
      this.variant = this.data.variants.find(variant => String(variant.id) === this.variantSelect.value) || this.data.variants[0];
      this.syncGalleryFormat(updateUrl);
      this.querySelectorAll('[name="hx_variant"]').forEach(input => { input.checked = input.value === String(this.variant.id); });
      const options = [];
      if (!this.variant.requiresPlan) options.push(new Option(this.data.oneTimeLabel, ''));
      this.variant.plans.forEach(plan => options.push(new Option(`${this.planLabel(plan)} — ${plan.priceFormatted}`, String(plan.id))));
      this.planSelect.replaceChildren(...options);
      const remembered = this.variant.plans.find(plan => String(plan.id) === previousPlan) || this.variant.plans.find(plan => plan.name === previousPlanName);
      const targetPlan = (this.explicitPlan && remembered) || this.recommendedPlan() || remembered || this.variant.plans[0];
      this.planSelect.value = (subscribing || this.variant.requiresPlan) && targetPlan ? String(targetPlan.id) : '';
      this.activePlan = targetPlan?.id;
      this.renderPlanChoices();
      this.querySelector('.hx-product-purchase-plans').hidden = this.variant.plans.length === 0;
      this.querySelector('[data-hx-onetime]').hidden = Boolean(this.variant.requiresPlan);
      this.querySelector('[data-hx-onetime-price]').textContent = this.variant.priceFormatted;
      this.quantity.min = this.variant.minimum;
      this.quantity.step = this.variant.increment;
      if (this.variant.maximum) this.quantity.max = this.variant.maximum;
      else this.quantity.removeAttribute('max');
      this.syncQuantity(true);
      const label = this.querySelector('[data-hx-sticky-variant]');
      if (label) label.textContent = this.data.hasOnlyDefaultVariant ? '' : ` · ${this.variant.title}`;
      this.setStatus('');
      this.syncPlan(updateUrl);
      if (updateUrl && this.variant.mediaId) {
        const index = this.media.findIndex(media => media.dataset.hxMedia === String(this.variant.mediaId));
        if (index >= 0) this.showMedia(index, true);
      }
    }
    responsiveImage(image, source, sizes = '(max-width: 749px) 88vw, 48vw', widths = [360,540,720,1080,1440]) {
      const url = new URL(source, location.href);
      if (url.pathname.includes('/files/')) {
        image.sizes = sizes;
        image.srcset = widths.map(width => {
          const candidate = new URL(url);
          candidate.searchParams.set('width', width);
          return `${candidate.href} ${width}w`;
        }).join(',');
        url.searchParams.set('width', widths[widths.length - 1]);
      }
      image.src = url.href;
    }
    setupChapters() {
      const source = this.querySelector('[data-hx-chapters]');
      if (!source) return;
      source.querySelectorAll(':scope > .metafield-rich_text_field').forEach(wrapper => wrapper.replaceWith(...wrapper.childNodes));
      const groups = [];
      let current;
      [...source.children].forEach(node => {
        const singleHeading = node.matches('ul,ol') && node.children.length === 1 && node.querySelector('li>strong');
        const heading = singleHeading || node.matches('h2,h3,h4');
        if (heading) {
          current = { heading: node.textContent.trim(), nodes: [], visualIndex: node.dataset.hxVisualIndex === undefined ? groups.length : Number(node.dataset.hxVisualIndex), icon: node.dataset.hxBenefitIcon };
          groups.push(current);
        } else if (current) current.nodes.push(node);
      });
      const meaningful = groups.filter(group => group.nodes.some(node => node.textContent.trim() || node.querySelector('img,video,table')));
      if (meaningful.length < 2 || meaningful.length !== groups.length) return;
      const allChildren = [...source.children];
      const firstHeading = allChildren.findIndex(node => node.matches('h2,h3,h4') || (node.matches('ul,ol') && node.children.length === 1 && node.querySelector('li>strong')));
      if (firstHeading > 0 && allChildren.slice(0, firstHeading).some(node => node.textContent.trim())) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'hx-product-chapters';
      const nav = document.createElement('div');
      nav.className = 'hx-product-chapter-nav';
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', source.dataset.chapterLabel);
      const panels = [], buttons = [];
      meaningful.forEach((group, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.id = `${source.dataset.chapterPrefix}-tab-${index}`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-label', group.heading);
        const number = document.createElement('span');
        number.className = 'hx-benefit-number hx-benefit-icon';
        number.setAttribute('aria-hidden', 'true');
        const benefitPaths = [
          'm12 3 2.4 6.6L21 12l-6.6 2.4L12 21l-2.4-6.6L3 12l6.6-2.4L12 3Z',
          'm13 2-9 12h7l-1 8L20 9h-7l1-7Z',
          'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z',
          'M12 3 4 6v6c0 5 8 9 8 9s8-4 8-9V6l-8-3Zm-4 9 3 3 5-6'
        ];
        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('viewBox', '0 0 24 24');
        icon.setAttribute('width', '20');icon.setAttribute('height', '20');
        icon.setAttribute('fill', 'none');icon.setAttribute('stroke', 'currentColor');
        icon.setAttribute('stroke-width', '1.5');icon.setAttribute('stroke-linecap', 'round');icon.setAttribute('stroke-linejoin', 'round');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        const rocket = 'M4.5 16.5C3 17.8 2.5 21.5 2.5 21.5s3.7-.5 5-2M9 15l-3-3c2-5 6-8.5 10-9.5 2-.5 4-.5 5.5-.5 0 1.5 0 3.5-.5 5.5-1 4-4.5 8-9.5 10l-3-3ZM6 12l-3-1.5c1.5-1.5 3.5-2.5 6-2.8M12 18l1.5 3c1.5-1.5 2.5-3.5 2.8-6M16 5.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 1 0 0-3Z';
        const nrPaths = { nad: rocket, energy: benefitPaths[1], skin: 'M12 3C9 7 5 10 5 14a7 7 0 0 0 14 0c0-4-4-7-7-11ZM8 14a4 4 0 0 0 4 4', fatigue: 'M9 3h6m-3 0v3M5 20h14M5 17a8 8 0 1 1 14 0M2 9l2 1m16 0 2-1M6 3l1 2m10 0 1-2m-5 5-4 5h4l-1 4 5-6h-4l1-3Z' };
        path.setAttribute('d', nrPaths[group.icon] || benefitPaths[index % benefitPaths.length]);icon.append(path);number.append(icon);
        const label = document.createElement('span');
        label.textContent = group.heading;
        const arrow = document.createElement('span');
        arrow.className = 'hx-benefit-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '↗';
        button.append(number, label, arrow);
        const panel = document.createElement('article');
        panel.id = `${source.dataset.chapterPrefix}-panel-${index}`;
        panel.className = 'hx-product-chapter-panel';
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
        panel.tabIndex = 0;
        button.setAttribute('aria-controls', panel.id);
        const title = document.createElement('h3');
        title.textContent = group.heading;
        panel.append(title, ...group.nodes);
        nav.append(button);
        panels.push(panel);
        buttons.push(button);
      });
      const visual = source.closest('.hx-product-story').querySelector('.hx-product-story-visual');
      const campaign = visual?.querySelector('[data-hx-campaign-shot]');
      const base = visual?.querySelector('[data-hx-benefit-base]');
      const campaignMap = JSON.parse(visual?.querySelector('[data-hx-campaign-map]')?.textContent || '{}');
      if (visual && Array.isArray(campaignMap)) {
        this.benefitPreloadObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.benefitPreloadObserver.disconnect();
          campaignMap.forEach(url => { const image = new Image(); image.fetchPriority = 'low'; this.responsiveImage(image, url); });
        }, { rootMargin: '600px' });
        this.benefitPreloadObserver.observe(visual);
      }
      const selectVisual = (index, animate) => {
        if (!campaign || !base) return;
        const topic = String(index + 1);
        const url = campaignMap[meaningful[index].visualIndex];
        const revision = this.campaignRevision = (this.campaignRevision || 0) + 1;
        if (!url) { campaign.hidden = true; base.hidden = false; return; }
        const preload = new Image();
        preload.onload = () => {
          if (revision !== this.campaignRevision || !this.isConnected) return;
          campaign.sizes = preload.sizes;
          campaign.srcset = preload.srcset;
          campaign.src = preload.src;
          campaign.dataset.topic = topic;
          campaign.hidden = false;
          base.hidden = true;
          if (animate) this.motion(campaign, [{ opacity: .2 }, { opacity: 1 }], 420);
        };
        preload.onerror = () => { if (revision === this.campaignRevision) { campaign.hidden = true; base.hidden = false; } };
        this.responsiveImage(preload, url);
      };
      const select = (index, animate) => {
        panels.forEach((panel, current) => {
          panel.hidden = current !== index;
          buttons[current].setAttribute('aria-selected', String(current === index));
          buttons[current].tabIndex = current === index ? 0 : -1;
        });
        selectVisual(index, animate);
        if (animate) {
          this.motion(panels[index], [{ opacity: .25, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], 300);
        }
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(index, true), this.events);
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + buttons.length - 1) % buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = buttons.length - 1;
          else return;
          event.preventDefault();
          select(next, true);
          buttons[next].focus();
        }, this.events);
      });
      const story = source.closest('.hx-product-story');
      const heading = story.querySelector('.hx-product-story-copy > h2');
      const stage = document.createElement('div');
      stage.className = 'hx-benefits-stage';
      if (visual) stage.append(visual);
      stage.append(...panels);
      wrapper.append(nav, stage);
      source.replaceChildren(wrapper);
      story.classList.add('hx-benefits-explorer');
      story.replaceChildren(heading, source);
      nav.setAttribute('aria-orientation', 'vertical');
      select(0, false);
      const overview = this.querySelector('[data-hx-benefit-overview]');
      const grid = overview?.querySelector('[data-hx-benefit-preview-grid]');
      if (grid && Array.isArray(campaignMap)) {
        const labels = JSON.parse(overview.querySelector('[data-hx-benefit-preview-labels]')?.textContent || 'null');
        grid.replaceChildren();
        meaningful.slice(0, 4).forEach((group, index) => {
          const target = labels?.targets?.[index] ?? index;
          const url = labels?.images?.[index] || campaignMap[group.visualIndex];
          if (!url) return;
          const card = document.createElement('a');
          card.className = 'hx-quality-card hx-benefit-preview-card';
          card.href = `#${source.closest('.hx-product-story').id}`;
          const image = document.createElement('img');
          image.alt = ''; image.loading = 'lazy'; image.width = 1200; image.height = 1600;
          this.responsiveImage(image, url, '(max-width: 749px) 78vw, (max-width: 989px) 44vw, 23vw', [360,540,720,1080]);
          const icon = document.createElement('span');
          icon.className = 'hx-quality-icon'; icon.setAttribute('aria-hidden', 'true');
          if (labels) {
            const paths = [
              ['M20 7a9 9 0 1 0 1 8M20 3v4h-4', 'M12 8c-5-4-8 3 0 8 8-5 5-12 0-8Z'],
              ['M13 2 4 14h7l-1 8 10-13h-7l1-7Z'],
              ['M4 11a8 8 0 0 1 14-5l2 2M20 3v5h-5M20 13a8 8 0 0 1-14 5l-2-2M4 21v-5h5'],
              ['M12 3C9 7 5 10 5 14a7 7 0 0 0 14 0c0-4-4-7-7-11Z', 'M8 14a4 4 0 0 0 4 4']
            ];
            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
            svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '1.5');
            svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
            paths[index].forEach(d => { const path = document.createElementNS(svg.namespaceURI, 'path'); path.setAttribute('d', d); svg.append(path); });
            icon.append(svg);
          } else icon.append(buttons[target].querySelector('svg').cloneNode(true));
          const copy = document.createElement('div'); copy.className = 'hx-quality-copy';
          const title = document.createElement('h3'); title.textContent = labels?.titles[index] || group.heading;
          const paragraph = document.createElement('p');
          paragraph.textContent = labels?.copy[index] || panels[target].querySelector('p')?.textContent || '';
          copy.append(title, paragraph); card.append(image, icon, copy);
          card.addEventListener('click', () => select(target, true), this.events);
          grid.append(card);
        });
        overview.hidden = !grid.children.length;
      }
    }
    setupReveals() {
      if (this.reduced.matches || !('IntersectionObserver' in window)) return;
      this.revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.motion(entry.target, [{ opacity: .3, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }], 450);
          this.revealObserver.unobserve(entry.target);
        });
      }, { threshold: .08 });
      this.querySelectorAll('[data-hx-reveal]').forEach(section => this.revealObserver.observe(section));
    }
    setupAmbientVideos() {
      this.ambientLoops = [...this.querySelectorAll('[data-hx-ambient]')].map(container => {
        const primary = container.querySelector('[data-hx-ambient-primary]');
        const secondary = primary.cloneNode(true);
        secondary.removeAttribute('data-hx-ambient-primary');
        secondary.classList.add('hx-product-ambient-secondary');
        container.append(secondary);
        const videos = [primary, secondary];
        videos.forEach(video => {
          video.autoplay = false;
          video.loop = false;
          video.controls = false;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.disablePictureInPicture = true;
          video.removeAttribute('controls');
          video.removeAttribute('poster');
        });
        const state = { active: 0, visible: false, loaded: false, running: false, starting: false, blending: false, incoming: null, frame: null, animation: null, epoch: 0 };
        const canPlay = () => state.visible && !document.hidden && !this.reduced.matches && Boolean(this.controller && !this.controller.signal.aborted);
        const cancelFrame = () => {
          if (state.frame === null) return;
          videos[state.active].cancelVideoFrameCallback?.(state.frame);
          state.frame = null;
        };
        const positionFrames = () => videos.forEach((video, index) => {
          video.style.opacity = state.running && index === state.active ? '1' : '0';
          video.style.zIndex = index === state.active ? '2' : '1';
        });
        const stop = () => {
          cancelFrame();
          state.epoch++;
          state.running = false;
          state.starting = false;
          if (state.incoming !== null) state.active = state.incoming;
          state.incoming = null;
          state.blending = false;
          state.animation?.cancel();
          state.animation = null;
          videos.forEach(video => video.pause());
          positionFrames();
        };
        const requestFrame = () => {
          if (!state.running || state.blending || !canPlay()) return;
          const video = videos[state.active];
          if (!video.requestVideoFrameCallback) return;
          state.frame = video.requestVideoFrameCallback(() => { state.frame = null; checkLoop(); requestFrame(); });
        };
        const crossfade = async () => {
          if (state.blending || !state.running || !canPlay()) return;
          state.blending = true;
          cancelFrame();
          const epoch = state.epoch;
          const oldIndex = state.active, nextIndex = 1 - oldIndex;
          const outgoing = videos[oldIndex], incoming = videos[nextIndex];
          try {
            incoming.currentTime = 0;
            incoming.style.opacity = '0';
            incoming.style.zIndex = '3';
            await incoming.play();
            if (epoch !== state.epoch || !canPlay()) { incoming.pause(); return; }
            state.incoming = nextIndex;
            const duration = Math.min(650, Math.max(100, outgoing.duration * 300));
            state.animation = incoming.animate([{ opacity: 0 }, { opacity: 1 }], { duration, easing: 'linear', fill: 'forwards' });
            await state.animation.finished;
            if (epoch !== state.epoch || !canPlay()) return;
            incoming.style.opacity = '1';
            state.animation.cancel();
            state.animation = null;
            outgoing.style.opacity = '0';
            outgoing.pause();
            outgoing.currentTime = 0;
            state.active = nextIndex;
            state.incoming = null;
            state.blending = false;
            positionFrames();
            requestFrame();
          } catch {
            if (epoch !== state.epoch) return;
            state.blending = false;
            state.incoming = null;
            state.animation?.cancel();
            state.animation = null;
            incoming.pause();
            outgoing.currentTime = 0;
            outgoing.play().catch(() => stop());
            positionFrames();
            requestFrame();
          }
        };
        const checkLoop = () => {
          const video = videos[state.active];
          if (!state.running || state.blending || !Number.isFinite(video.duration) || video.duration <= 0) return;
          const overlap = Math.min(.65, video.duration * .3);
          if (video.duration - video.currentTime <= overlap + .07 || video.ended) crossfade();
        };
        const start = async () => {
          if (!canPlay() || state.running || state.starting) return;
          if (!state.loaded) {
            videos.forEach(video => { video.src = container.dataset.videoSrc; video.preload = 'auto'; video.load(); });
            state.loaded = true;
          }
          const epoch = state.epoch;
          state.starting = true;
          const video = videos[state.active];
          try {
            if (video.ended) video.currentTime = 0;
            await video.play();
            if (epoch !== state.epoch || !canPlay()) { video.pause(); return; }
            state.starting = false;
            state.running = true;
            positionFrames();
            requestFrame();
          } catch { if (epoch === state.epoch) stop(); }
        };
        videos.forEach(video => {
          video.addEventListener('timeupdate', checkLoop, this.events);
          video.addEventListener('ended', checkLoop, this.events);
        });
        return { container, state, start, stop, destroy: () => { stop(); secondary.remove(); } };
      });
      if (!this.ambientLoops.length) return;
      const sync = () => this.ambientLoops.forEach(loop => {
        if (loop.state.visible && !document.hidden && !this.reduced.matches) loop.start();
        else loop.stop();
      });
      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const loop = this.ambientLoops.find(item => item.container === entry.target);
            loop.state.visible = entry.isIntersecting;
          });
          sync();
        }, { threshold: .12 });
        this.ambientLoops.forEach(loop => this.videoObserver.observe(loop.container));
      }
      document.addEventListener('visibilitychange', sync, this.events);
      this.reduced.addEventListener('change', sync, this.events);
    }
    setupRecommendations() {
      const target = this.querySelector('[data-hx-recommendations]');
      if (!target) return;
      if (target.childElementCount) { this.setupRecommendationCarousel(target); return; }
      const load = async () => {
        try {
          const response = await fetch(target.dataset.url, { signal: this.controller.signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = html.querySelector('[data-hx-recommendations]');
          if (content?.childElementCount && this.isConnected) {
            target.replaceChildren(...content.children);
            this.setupRecommendationCarousel(target);
          }
        } catch {}
      };
      if ('IntersectionObserver' in window) {
        this.recommendationObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.recommendationObserver.disconnect(); load(); }
        }, { rootMargin: '300px' });
        this.recommendationObserver.observe(target);
      } else load();
    }
    setupRecommendationCarousel(target) {
      const track = target.querySelector('[data-hx-recommendation-track]');
      if (!track || track.children.length < 2) return;
      const cards = [...track.children];
      const controls = target.querySelector('[data-hx-carousel-controls]');
      const toggle = target.querySelector('[data-hx-carousel-toggle]');
      const counter = target.querySelector('[data-hx-carousel-current]');
      const state = { index: 0, paused: this.reduced.matches, visible: false, hovering: false, focused: false };
      controls.hidden = false;
      const updateToggle = () => {
        toggle.setAttribute('aria-label', state.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        toggle.setAttribute('aria-pressed', String(state.paused));
        toggle.querySelector('.hx-ui-icon path')?.setAttribute('d', state.paused ? 'm9 5 11 7-11 7Z' : 'M8 5v14M16 5v14');
      };
      const move = step => {
        state.index = (state.index + step + cards.length) % cards.length;
        track.scrollTo({ left: cards[state.index].offsetLeft, behavior: this.reduced.matches ? 'instant' : 'smooth' });
        counter.textContent = String(state.index + 1);
      };
      const schedule = () => {
        clearTimeout(this.recommendationTimer);
        if (state.paused || !state.visible || state.hovering || state.focused || document.hidden || this.reduced.matches) return;
        this.recommendationTimer = setTimeout(() => { move(1); schedule(); }, 4800);
      };
      const pause = () => { state.paused = true; updateToggle(); schedule(); };
      target.querySelectorAll('[data-hx-carousel-step]').forEach(button => button.addEventListener('click', () => {
        pause();
        move(Number(button.dataset.hxCarouselStep));
      }, this.events));
      toggle.addEventListener('click', () => { state.paused = !state.paused; updateToggle(); schedule(); }, this.events);
      track.addEventListener('pointerdown', pause, this.events);
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        pause();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, this.events);
      track.addEventListener('scroll', () => {
        clearTimeout(this.recommendationScrollTimer);
        this.recommendationScrollTimer = setTimeout(() => {
          const maximum = track.scrollWidth - track.clientWidth;
          state.index = cards.reduce((nearest, card, index) => Math.abs(Math.min(card.offsetLeft, maximum) - track.scrollLeft) < Math.abs(Math.min(cards[nearest].offsetLeft, maximum) - track.scrollLeft) ? index : nearest, 0);
          counter.textContent = String(state.index + 1);
        }, 100);
      }, { passive: true, signal: this.controller.signal });
      target.addEventListener('pointerenter', event => { if (event.pointerType !== 'mouse') return; state.hovering = true; schedule(); }, this.events);
      target.addEventListener('pointerleave', () => { state.hovering = false; schedule(); }, this.events);
      target.addEventListener('focusin', () => { state.focused = true; schedule(); }, this.events);
      target.addEventListener('focusout', event => { state.focused = target.contains(event.relatedTarget); schedule(); }, this.events);
      document.addEventListener('visibilitychange', schedule, this.events);
      this.reduced.addEventListener('change', () => { if (this.reduced.matches) pause(); else schedule(); }, this.events);
      this.recommendationCarouselObserver = new IntersectionObserver(entries => {
        state.visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .25);
        schedule();
      }, { threshold: .25 });
      this.recommendationCarouselObserver.observe(target);
      updateToggle();
    }
    setupTestimonials() {
      const cards = [...this.querySelectorAll('[data-hx-testimonial]')];
      if (!cards.length) return;
      const videos = cards.map(card => card.querySelector('video'));
      const visible = new Set();
      const stop = video => { video.pause(); video.muted = true; };
      const syncPlayback = () => cards.forEach(card => {
        const video = card.querySelector('video');
        if (!visible.has(card) || document.hidden || this.reduced.matches) stop(video);
        else if (video.paused) { video.muted = true; video.play().catch(() => {}); }
      });
      cards.forEach(card => {
        const video = card.querySelector('video');
        const sound = card.querySelector('[data-hx-testimonial-sound]');
        video.controls = false;
        video.autoplay = false;
        video.loop = true;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.disablePictureInPicture = true;
        video.removeAttribute('controls');
        const sync = () => {
          const playing = !video.paused && !video.ended;
          sound.setAttribute('aria-label', video.muted ? sound.dataset.unmuteLabel : sound.dataset.muteLabel);
          sound.setAttribute('aria-pressed', String(!video.muted));
          sound.querySelector('[data-hx-muted-icon]').toggleAttribute('hidden', !video.muted);
          card.classList.toggle('is-playing', playing);
        };
        sound.addEventListener('click', async () => {
          const enableSound = video.muted;
          videos.filter(other => other !== video).forEach(other => { other.muted = true; });
          video.muted = !enableSound;
          if (enableSound && video.paused) {
            try { await video.play(); } catch { video.muted = true; }
          }
          sync();
        }, this.events);
        ['play', 'pause', 'ended', 'volumechange'].forEach(name => video.addEventListener(name, sync, this.events));
        sync();
      });
      if ('IntersectionObserver' in window) {
        this.testimonialObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= .1) visible.add(entry.target);
            else visible.delete(entry.target);
          });
          syncPlayback();
        }, { threshold: .1 });
        cards.forEach(card => this.testimonialObserver.observe(card));
      } else {
        cards.forEach(card => visible.add(card));
        syncPlayback();
      }
      this.querySelectorAll('[data-hx-testimonial-gallery]').forEach(gallery => {
        const track = gallery.querySelector('[data-hx-testimonial-track]');
        const previous = gallery.querySelector('[data-hx-testimonial-step="-1"]');
        const next = gallery.querySelector('[data-hx-testimonial-step="1"]');
        if (!previous || !next) return;
        const updateNavigation = () => {
          previous.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        gallery.querySelectorAll('[data-hx-testimonial-step]').forEach(button => button.addEventListener('click', () => {
          track.scrollBy({ left: track.clientWidth * .8 * Number(button.dataset.hxTestimonialStep), behavior: this.reduced.matches ? 'auto' : 'smooth' });
        }, this.events));
        track.addEventListener('scroll', updateNavigation, { passive: true, ...this.events });
        addEventListener('resize', updateNavigation, this.events);
        updateNavigation();
      });
      document.addEventListener('visibilitychange', syncPlayback, this.events);
      this.reduced.addEventListener('change', syncPlayback, this.events);
    }
    planDays(plan) {
      const deliveryDays = Number(plan.deliveryDays);
      if (Number.isFinite(deliveryDays) && deliveryDays > 0) return deliveryDays;
      const name = plan.name.toLowerCase();
      const count = Number(name.match(/\d+/)?.[0]) || (/varannan/.test(name) ? 2 : /tredje/.test(name) ? 3 : /sjätte/.test(name) ? 6 : 1);
      if (/week|weken|semaine|woche|settim|semana|veck/.test(name)) return count * 7;
      if (/month|mensuel|mensil|mois|monat|mese|mesi|mensual|mes(?:es)?\b|maand|månad/.test(name)) return count * 30;
      return 0;
    }
    recommendedPlan() {
      const days = this.variant.duration || 30;
      const plans = this.variant.plans.filter(plan => this.planDays(plan) >= 30);
      return plans.sort((a,b) => Math.abs(this.planDays(a)-days)-Math.abs(this.planDays(b)-days))[0] || this.variant.plans[0];
    }
    syncCadenceNote() {
      const note = this.querySelector('[data-hx-cadence-note]');
      if (!note || !this.variant) return;
      const days = this.variant.duration;
      const plan = this.variant.plans.find(item => !this.planSelect.disabled && String(item.id) === this.planSelect.value);
      const mismatch = plan && days > 0 && Math.abs(this.planDays(plan)-days) > 14;
      note.hidden = !mismatch;
      note.textContent = mismatch ? this.data.labels.mismatch.replace('[days]',days).replace('[frequency]',this.planLabel(plan)) : '';
    }
    planLabel(plan) {
      const days = this.planDays(plan), labels = this.data.labels;
      if (document.documentElement.lang.toLowerCase().startsWith('sv') && /^leverans /i.test(plan.name)) return plan.name.replace(/^leverans /i, '');
      return days === 30 ? labels.monthly : days && days < 30 ? labels.weeks.replace('[count]',days / 7) : days ? labels.months.replace('[count]',days / 30) : plan.name;
    }
    setPlanList(open, focus = false) {
      this.planChoices.hidden = !open;
      this.planTrigger.setAttribute('aria-expanded',String(open));
      if (open) this.motion(this.planChoices,[{opacity:0,transform:'translateY(-5px)'},{opacity:1,transform:'translateY(0)'}],180);
      if (focus) (open ? this.planChoices.querySelector('[aria-checked="true"]') || this.planChoices.firstElementChild : this.planTrigger)?.focus();
    }
    renderPlanChoices() {
      const container = this.querySelector('.hx-product-plan-select');
      if (!container) return;
      if (!this.planChoices) {
        this.planChoices = document.createElement('div');
        this.planChoices.className = 'hx-plan-options';
        this.planChoices.setAttribute('role', 'radiogroup');
        const label = container.querySelector('label');
        if (label) {
          label.id = `${this.planSelect.id}-label`;
          this.planChoices.setAttribute('aria-labelledby', label.id);
        }
        this.planChoices.id = `${this.planSelect.id}-choices`;
        this.planChoices.hidden = true;
        this.planTrigger = document.createElement('button');
        this.planTrigger.type = 'button';
        this.planTrigger.className = 'hx-cadence-trigger';
        this.planTrigger.setAttribute('aria-expanded','false');
        this.planTrigger.setAttribute('aria-controls',this.planChoices.id);
        this.planTriggerLabel = document.createElement('span');
        const chevron = document.createElementNS('http://www.w3.org/2000/svg','svg');
        chevron.setAttribute('viewBox','0 0 24 24');
        chevron.setAttribute('aria-hidden','true');
        const path = document.createElementNS('http://www.w3.org/2000/svg','path');
        path.setAttribute('d','m6 9 6 6 6-6');chevron.append(path);
        this.planTrigger.append(this.planTriggerLabel,chevron);
        container.append(this.planTrigger,this.planChoices);
        this.planTrigger.addEventListener('click',()=>this.setPlanList(this.planChoices.hidden),this.events);
        this.planTrigger.addEventListener('keydown',event=>{if(event.key==='ArrowDown'){event.preventDefault();this.setPlanList(true,true);}},this.events);
        container.addEventListener('keydown',event=>{if(event.key==='Escape'&&!this.planChoices.hidden){event.preventDefault();event.stopPropagation();this.setPlanList(false,true);}},this.events);
        container.addEventListener('focusout',event=>{if(!container.contains(event.relatedTarget))this.setPlanList(false);},this.events);
        document.addEventListener('pointerdown',event=>{if(!container.contains(event.target))this.setPlanList(false);},this.events);
        this.planSelect.classList.add('hx-plan-native');
        this.planSelect.hidden = true;
      }
      const showPrices = new Set(this.variant.plans.map(plan => plan.price)).size > 1;
      const buttons = this.variant.plans.map((plan, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'hx-plan-option';
        button.dataset.hxPlanChoice = String(plan.id);
        button.setAttribute('role', 'radio');
        const indicator = document.createElement('span');
        indicator.className = 'hx-plan-check';
        indicator.setAttribute('aria-hidden', 'true');
        const label = document.createElement('span');
        label.className = 'hx-plan-name';
        label.textContent = this.planLabel(plan);
        button.setAttribute('aria-label', `${this.planLabel(plan)} — ${plan.priceFormatted}`);
        button.append(indicator, label);
        if (showPrices) {
          const price = document.createElement('span');
          price.className = 'hx-plan-price';
          price.textContent = plan.priceFormatted;
          button.append(price);
        }
        const choose = () => {
          this.explicitPlan = true;
          this.planSelect.value = String(plan.id);
          this.syncPlan(true);
          this.setPlanList(false,true);
        };
        button.addEventListener('click', choose, this.events);
        button.addEventListener('keydown', event => {
          const targets = { ArrowRight: (index + 1) % buttons.length, ArrowDown: (index + 1) % buttons.length, ArrowLeft: (index + buttons.length - 1) % buttons.length, ArrowUp: (index + buttons.length - 1) % buttons.length, Home: 0, End: buttons.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          buttons[targets[event.key]].focus();
        }, this.events);
        return button;
      });
      this.planChoices.replaceChildren(...buttons);
      this.setPlanList(false);
    }
    syncPlan(updateUrl) {
      const plan = this.variant.plans.find(item => String(item.id) === this.planSelect.value);
      const subscribing = Boolean(plan);
      if (plan) {
        this.activePlan = plan.id;
        this.planTriggerLabel.textContent = this.planLabel(plan);
        this.planTrigger.setAttribute('aria-label',this.querySelector('.hx-product-plan-select>label').textContent.trim().replace(/\s*:\s*$/, '') + ' : ' + this.planLabel(plan));
      }
      this.planSelect.disabled = !subscribing;
      this.querySelectorAll('[data-hx-plan-choice]').forEach(button => {
        const selected = button.dataset.hxPlanChoice === this.planSelect.value;
        button.setAttribute('aria-checked', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      this.querySelector('.hx-product-plan-select').hidden = !subscribing;
      const subscriptionDetails = this.querySelector('[data-hx-subscription-details]');
      if (subscriptionDetails) subscriptionDetails.hidden = !subscribing;
      this.querySelectorAll('[data-hx-one-time-payment]').forEach(node => { node.hidden = subscribing; });
      this.querySelectorAll('[name="hx_purchase_mode"]').forEach(input => { input.checked = input.value === (subscribing ? 'subscription' : 'one_time'); });
      const subPrice = plan || this.variant.plans.find(item => item.id === this.activePlan) || this.variant.plans[0];
      if (subPrice) this.querySelector('[data-hx-subscription-price]').textContent = subPrice.priceFormatted;
      const discount = subPrice && this.variant.price > subPrice.price ? Math.round((this.variant.price - subPrice.price) * 100 / this.variant.price) : 0;
      this.querySelectorAll('[data-hx-subscription-saving]').forEach(node => { node.textContent = discount ? `−${discount} %` : ''; node.hidden = !discount; });
      const loyaltyPlacement = this.querySelector('[data-hx-loyalty-placement]');
      if (loyaltyPlacement) loyaltyPlacement.hidden = !plan;
      const price = plan || this.variant;
      this.querySelectorAll('[data-hx-price]').forEach(node => {
        if (node.textContent !== price.priceFormatted) {
          node.textContent = price.priceFormatted;
          this.motion(node, [{ opacity: .2, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], 400);
        }
      });
      const compare = this.querySelector('[data-hx-compare]');
      const saving = this.querySelector('[data-hx-saving]');
      const discounted = price.comparePrice > price.price;
      compare.hidden = !discounted;
      saving.hidden = !discounted;
      compare.textContent = price.compareFormatted;
      saving.textContent = discounted ? `−${Math.round((price.comparePrice - price.price) * 100 / price.comparePrice)} %` : '';
      this.querySelectorAll('[data-hx-variant-price], [data-hx-unit-price]').forEach(label => {
        const variant = this.data.variants.find(item => String(item.id) === (label.dataset.hxVariantPrice || label.dataset.hxUnitPrice));
        const matchedPlan = subscribing ? variant.plans.find(item => String(item.id) === String(plan.id)) || variant.plans.find(item => item.name === plan.name) || variant.plans[0] : null;
        const formatPrice = matchedPlan || variant;
        label.textContent = label.hasAttribute('data-hx-unit-price') ? this.data.labels.capsulePrice.replace('[price]', formatPrice.unitPriceFormatted) : formatPrice.priceFormatted;
      });
      const deliverySummary = this.querySelector('[data-hx-delivery-summary]');
      if (deliverySummary) deliverySummary.textContent = plan ? this.data.deliverySummaryLabel.replace('[price]', plan.priceFormatted) + ' · ' + this.planLabel(plan) : this.data.labels.once.replace('[price]', this.variant.priceFormatted);
      this.syncCadenceNote();
      this.updateButtons();
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', this.variant.id);
        if (plan) url.searchParams.set('selling_plan', plan.id);
        else url.searchParams.delete('selling_plan');
        if (plan) url.searchParams.delete('purchase_option');
        else url.searchParams.set('purchase_option', 'one_time');
        history.replaceState({}, '', url);
      }
    }
    syncQuantity(normalize) {
      const minimum = this.variant?.minimum || 1;
      const increment = this.variant?.increment || 1;
      const maximum = this.variant?.maximum || Infinity;
      if (normalize) {
        let value = Math.max(minimum, Number(this.quantity.value) || minimum);
        value = minimum + Math.ceil((value - minimum) / increment) * increment;
        this.quantity.value = Math.min(value, maximum);
      }
      this.syncCadenceNote();
      this.querySelectorAll('[data-hx-quantity-display]').forEach(node => { node.textContent = this.quantity.value || minimum; });
      this.querySelectorAll('[data-hx-quantity-step="-1"]').forEach(button => { button.disabled = Number(this.quantity.value) <= minimum; });
      this.querySelectorAll('[data-hx-quantity-step="1"]').forEach(button => { button.disabled = Number(this.quantity.value) >= maximum; });
    }
    updateButtons() {
      this.querySelectorAll('[data-hx-stock-notice]').forEach(notice => { notice.hidden = !this.variant.available; });
      this.querySelectorAll('[data-hx-add]').forEach(button => {
        button.disabled = this.busy || !this.variant.available;
        button.querySelector('[data-hx-add-text]').textContent = this.busy ? this.dataset.pending : this.variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
      });
    }
    setStatus(message, state = 'idle') {
      this.status.textContent = message;
      this.status.dataset.state = state;
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.variant.available || !this.form.reportValidity()) return;
      this.busy = true;
      this.updateButtons();
      this.form.setAttribute('aria-busy', 'true');
      this.setStatus(this.dataset.pending, 'pending');
      this.querySelector('.hx-product-recovery').hidden = true;
      const drawer = document.querySelector('arte-cart-drawer');
      const payload = new FormData(this.form);
      payload.delete('hx_variant');
      payload.delete('hx_purchase_mode');
      payload.set('id', this.variant.id);
      payload.set('quantity', this.quantity.value);
      payload.delete('selling_plan');
      const plan = !this.planSelect.disabled && this.variant.plans.find(item => String(item.id) === this.planSelect.value);
      if (plan) payload.set('selling_plan', plan.id);
      if (drawer?.renderCart) {
        payload.set('sections', drawer.dataset.section);
        payload.set('sections_url', location.pathname);
      }
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
        const result = await response.json();
        if (!response.ok) {
          this.setStatus(typeof result.description === 'string' ? result.description : this.dataset.error, 'error');
          return;
        }
        if (drawer?.renderCart && drawer.renderCart(result.sections)) {
          this.setStatus(this.dataset.success, 'success');
          await drawer.open(event.submitter || this.querySelector('[data-hx-add]'));
          drawer.status(this.dataset.success, false, 'success');
        } else location.assign(this.dataset.cartUrl);
      } catch {
        this.setStatus(this.dataset.error, 'error');
        this.querySelector('.hx-product-recovery').hidden = false;
      } finally {
        this.busy = false;
        this.form.removeAttribute('aria-busy');
        this.updateButtons();
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.revealObserver?.disconnect();
      this.videoObserver?.disconnect();
      this.recommendationObserver?.disconnect();
      this.recommendationCarouselObserver?.disconnect();
      clearTimeout(this.recommendationTimer);
      clearTimeout(this.recommendationScrollTimer);
      this.benefitPreloadObserver?.disconnect();
      clearTimeout(this.emptyCartTimer);
      this.ambientLoops?.forEach(loop => loop.destroy());
      this.testimonialObserver?.disconnect();
      this.querySelectorAll('[data-hx-testimonial] video').forEach(video => video.pause());
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.lightbox?.open) this.lightbox.close();
      document.body.classList.remove('hx-product-sticky-active', 'hx-product-lightbox-open');
    }
  });
}



